import template from './employee_add_linked_leave.html';
import * as Permissions from '../../lib/permission_utils.js';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class EmployeeCreateLinkLeaveViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog
		this.ll_date_start = ko.observable()
		this.leave_type_id = ko.observable()
		this.allowed_values = ko.observableArray([ko.observable('')])
		this.ll_cycle_date = ko.observable()
		this.available_leave_types = ko.observableArray()

		this.ll_date_start.subscribe((val) => {
			if (this.ll_date_start() && this.ll_cycle_date()) {
				if (this.ll_date_start() > this.ll_cycle_date()) this.ll_cycle_date(val)
			}
		})

		this.ll_cycle_date.subscribe((val) => {
			if (this.ll_date_start() && this.ll_cycle_date()) {
				if (this.ll_date_start() > this.ll_cycle_date()) this.ll_date_start(val)
			}
		})
	}

	async save_linked_leave ()
	{

		if (!this.has_valid_dates())
		{
			Grape.alerts.alert({
				type: 'error',
				message: tr('Please select both start date and cycle start date.', 'Please select both start date and cycle start date.'),
				title: tr('Error', 'Error'),
			})
			return;
		}

		let obj = {
			employee_id: this.dialog.bindings.employee_id,
			leave_type_id: this.leave_type_id(),
			date_start: this.ll_date_start(),
			cycle_date_start: this.ll_cycle_date(),
		}

		let res = await Grape.fetches.postJSON('/employee/save_linked_leave', obj)
		if (res.status == 'OK') {
			Grape.alerts.alert({ type: 'success', message: tr('Successfully added linked leave.', 'Successfully added linked leave.'), title: tr('Success', 'Success') })
			this.dialog.close()
		} else if (res.status == 'ERROR') Grape.alerts.apiError(res)
		else Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') })
	}

	async start_linked_leave_tutorial() {
		let result = await Grape.fetches.getJSON('/api/setting/system.tutorial_start_linked_leave_tutorial', {})

		if (result) {
			if (result.value === true && Permissions.isLoggedInUser_Admin()) {
				let options_before = {
					steps: [
						{
							element: '#leave-type',
							intro: 'The leave type to assign to the employee.',
							position: 'right',
						},
						{
							element: '#date-start',
							intro: 'The date the employee started working.',
							position: 'right',
						},
						{
							element: '#cycle-start',
							intro: 'The date the leave cycle starts.',
							position: 'right',
						},
					],
				
				}

				Grape.fetches.patchJSON = (url, data, callback) => {
					$.ajax({
						url: url,
						type: 'PATCH',
						contentType: 'application/json',
						data: JSON.stringify(data),
						success: callback,
						error: () => { },
					})
				}

				let intro = introJs();
				let dialog_element = document.querySelector('dialog');
				dialog_element.addEventListener('open', () => {
					intro.setOptions(options_before);
					intro.start().onexit(async () => {
						await Grape.fetches.patchJSON('/api/setting/' + 'system.tutorial_start_linked_leave_tutorial', { name: 'system.tutorial_start_linked_leave_tutorial', value: false })
					});
				});
			}
		}
	}

	is_valid_date(date)
	{
		return date instanceof Date && !isNaN(date);
	}

	has_valid_dates()
	{
		let start_date = this.ll_date_start();
		let cycle_date = this.ll_cycle_date();
		return this.is_valid_date(new Date(start_date)) && this.is_valid_date(new Date(cycle_date));
	}

	close()
	{
		this.dialog.close()
	}
}

class EmployeeCreateLinkedLeavePage
{
	constructor (bindings)
	{
		this.viewModel = new EmployeeCreateLinkLeaveViewModel(this);
		this.bindings = bindings;
	}

	async init()
	{
		let res = await Grape.fetches.postJSON('/leave/get_available_linked_leave_selection', { 'employee_id': this.bindings.employee_id });

		if (res)
		{
			this.viewModel.available_leave_types(res);

			// find start date
			let ei = ko.mapping.toJS(this.bindings.employment_info);
			let start_date = '';
			for (let a = 0; a < ei.length; a++)
			{
				if (ei[a].active == true)
				{
					start_date = ei[a].date_started;
					break;
				}
			}

			if (start_date != '')
			{
				let mydate = new Date(start_date);
				mydate.setDate(25);

				if (mydate < new Date(start_date))
					mydate.setMonth(mydate.getMonth() + 1);

				this.viewModel.ll_date_start(Utils.toJSONDateString(new Date(start_date)));
				this.viewModel.ll_cycle_date(Utils.toJSONDateString(new Date(start_date)));
			}
			this.viewModel.start_linked_leave_tutorial();

		}
		else
			Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...', 'Something went wrong...'), title: tr('Error', 'Error') })	
	}


	addOtherName ()
	{
		this.viewModel.allowed_values.push(ko.observable(''));
	}
}

export default {
	name: 'EmployeeAddLinkedLeave',
	dialog_class: EmployeeCreateLinkedLeavePage,
	template: template,
	template_filename: 'translation/dialogs/employee_add_linked_leave',
	provider: 'ps'
};
